webpackJsonp([187831543564168],{

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreGenerateComponent = __webpack_require__(104);
	
	var _LoreGenerateComponent2 = _interopRequireDefault(_LoreGenerateComponent);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreGenerateComponent2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      '--es*'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can change which version of ES the component is generated in by passing in a language flag. By default, components are generated in ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'ES5'
	      ),
	      ' syntax.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      lore generate component MyComponent --es5\n      lore generate component MyComponent --es6\n      lore generate component MyComponent --esnext\n      ' }),
	    _react2.default.createElement(
	      _CodeTabs2.default,
	      null,
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES5', text: '\n        import React from \'react\';\n        import createReactClass from \'create-react-class\';\n        import PropTypes from \'prop-types\';\n\n        export default createReactClass({\n          displayName: \'MyComponent\',\n\n          propTypes: {},\n\n          render() {\n            return (\n              <div></div>\n            );\n          }\n        });\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ES6', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class MyComponent extends React.Component {\n\n          constructor(props) {\n            super(props);\n\n            // Set your initial state here\n            // this.setState = {};\n\n            // Bind your custom methods so you can access the expected \'this\'\n            // this.myCustomMethod = this.myCustomMethod.bind(this);\n          }\n\n          render() {\n            return (\n              <div></div>\n            );\n          }\n\n        }\n\n        MyComponent.propTypes = {};\n\n        export default MyComponent;\n        ' }),
	      _react2.default.createElement(_CodeTab2.default, { syntax: 'ESNext', text: '\n        import React from \'react\';\n        import PropTypes from \'prop-types\';\n\n        class MyComponent extends React.Component {\n\n          static propTypes = {};\n\n          constructor(props) {\n            super(props);\n\n            // Set your initial state here\n            // this.setState = {};\n\n            // Bind your custom methods so you can access the expected \'this\'\n            // this.myCustomMethod = this.myCustomMethod.bind(this);\n          }\n\n          render() {\n            return (\n              <div></div>\n            );\n          }\n\n        }\n\n        export default MyComponent;\n        ' })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cli-lore-generate-component-options-es-js-2f195bf96e7250c4656e.js